import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@ups/xplat/core';

import { IDynamicModelGroup } from '@ups/xplat/dynamic-render';
import { DynamicRenderService } from '@ups/xplat/dynamic-render';
import { DynamicContainerComponent } from '../../containers';

@Component({
  selector: 'ups-dynamic-edit-modal',
  templateUrl: 'dynamic-edit-modal.component.html',
  standalone: false,
})
export class DynamicEditModalComponent extends BaseComponent {
  show = false;
  @Input() editing = false;
  @Input() dynamicGroup: IDynamicModelGroup;
  @Input() title: string = null;
  /** Useful if the dialog should be read only */
  @Input() hideSaveButton = false;
  @Input() cancelButtonLabel: string;
  @ViewChild(DynamicContainerComponent)
  dynamicContainerComponent: DynamicContainerComponent;

  @Output() saveChanges = new EventEmitter<void>();

  constructor(public dynamicRender: DynamicRenderService) {
    super();
  }

  get isFormValid(): boolean {
    return this.dynamicContainerComponent?.form?.valid ?? false;
  }

  open(scrollToTop = true) {
    this.show = true;
    if (scrollToTop) {
      setTimeout(() => {
        scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }, 5);
    }
  }

  save() {
    this.saveChanges.emit();
  }

  hide() {
    this.show = false;
  }
}
